import { useEmitter } from "@/services/useEmitter";

const CUSTOM_CKEDITOR_ACTION = "custom_ckeditor";

export const WORK_CATEGORY_DESCRIPTION_TEMPLATE_CONFIRM_EVENT = "request-work-category-description-template-confirm";

const hasTemplateValue = value => {
  if (typeof value === "string") return value.trim().length > 0;

  return value !== undefined && value !== null && value !== "";
};

const confirmTemplateApply = grid =>
  new Promise(resolve => {
    const request = {
      grid,
      handled: false,
      markHandled() {
        this.handled = true;
      },
      resolve,
    };

    useEmitter().emit(WORK_CATEGORY_DESCRIPTION_TEMPLATE_CONFIRM_EVENT, request);

    if (!request.handled) {
      resolve(false);
    }
  });

export const resolveWorkCategoryDescriptionTemplateValue = async (backendValue, previousValue, grid) => {
  if (previousValue) {
    if (!hasTemplateValue(backendValue)) return previousValue || "";

    const shouldApplyTemplate = await confirmTemplateApply(grid);

    return shouldApplyTemplate ? backendValue : previousValue || "";
  } else {
    return backendValue || "";
  }
};

export const isWorkCategoryDescriptionTemplateRequest = parentParams => {
  const action = parentParams?.action || "";

  return action.includes(CUSTOM_CKEDITOR_ACTION);
};
